import { FunctionComponent, useEffect, useRef } from 'react';
import { startSnowfall } from './snowfall';

import classes from './Snowflakes.module.scss';

export const Snowflakes: FunctionComponent = () => {
  const canvasRef = useRef<HTMLCanvasElement>(null);

  useEffect(() => {
    const { current: canvas } = canvasRef;

    if (!canvas || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      return;
    }

    return startSnowfall(canvas);
  }, []);

  return <canvas ref={canvasRef} aria-hidden={'true'} className={classes['snowflakes']} />;
};
